export const CRYPTO_MARKET_DATA_SOURCE = Object.freeze({
  SELF_BUILT: 1,
  POLYMARKET: 2,
});

/** 与侧栏 CRYPTO_PRICE_SLUG_MAP / Go cryptoSidebarPeriodTags 对齐（小写）。 */
export const CRYPTO_SIDEBAR_PERIOD_TAG_SLUGS = Object.freeze(
  new Set(['5m', '15m', '1h', '4h', 'daily', 'weekly', 'monthly', 'yearly', 'pre-market', 'etf'])
);

/** CollectionVo 的来源以首个 market 为准；旧响应缺 market 时兼容 collection.dataSource。 */
export function resolveCryptoFeedDataSource(row) {
  const markets = Array.isArray(row?.markets) ? row.markets : [];
  const raw = markets[0]?.dataSource ?? row?.dataSource;
  const value = Number(raw);
  return Number.isFinite(value) ? value : null;
}

export function cryptoFeedRowHasSidebarPeriodTag(row) {
  const tags = Array.isArray(row?.tags) ? row.tags : [];
  return tags.some((tag) =>
    CRYPTO_SIDEBAR_PERIOD_TAG_SLUGS.has(String(tag?.slug || '').trim().toLowerCase())
  );
}

/**
 * 加密周期盘只留自建：updown 或侧栏周期 tag 的 PM 行一律丢弃。
 * 普通非周期 PM 加密事件保留；来源缺失时保守保留。
 */
export function shouldKeepCryptoFeedRowBySource(row, isUpdown) {
  const dataSource = resolveCryptoFeedDataSource(row);
  if (dataSource == null || dataSource !== CRYPTO_MARKET_DATA_SOURCE.POLYMARKET) {
    return true;
  }
  if (isUpdown || cryptoFeedRowHasSidebarPeriodTag(row)) {
    return false;
  }
  return true;
}
